import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { ArchivosSubidosInterface, ArchivosSubidosResponseInterface } from 'app/models/archivos-subidos-model';
import { UtilsService } from 'app/modules/utils-service';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class GaleriaService {
    archivosGaleria: BehaviorSubject<ArchivosSubidosInterface[]> = new BehaviorSubject<ArchivosSubidosInterface[]>([])

    constructor(private apiService:ApiService, private utilsService:UtilsService) { }

    get archivosGaleria$() {
        return this.archivosGaleria.asObservable();
    }

    getArchivosGaleria(uu_id: string): void {
        const url = `/archivos`;
        const params = { entidadUuid: uu_id };

        this.apiService.GetMethod(url, params, 'Error al obtener archivos de la Galería.')
            .subscribe(async (response: ArchivosSubidosResponseInterface) => {
            const archivosConURL = await Promise.all(
                response.data.map(async archivo => {
                const url = await this.utilsService.getArchivosInternos(archivo.archivoId)
                    .catch(() => null);
                return {
                    ...archivo,
                    blobURL: url
                };
                })
            );

            this.archivosGaleria.next(archivosConURL);
            });
    }

    putArchivoFavorito(uu_id:string, archivo_uu_id:number){
        const url= `/archivos/favorito/${uu_id}` 
        let params={archivoId:archivo_uu_id}
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, {}, params, 'Error al actualizar archivo favorito.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    eliminarArchivo(archivo_uu_id:number){
        const url= `/archivos/${archivo_uu_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.DeleteMethod(url, {}, 'Error al borrar archivo.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    actualizarNombreImagen(nombreArchivo:string, img_uui:number){
        const url= `/archivos/actualizar-nombre/${img_uui}` 
        let body={nombreArchivo:nombreArchivo}
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al actualizar nombre de imagen.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }
    
}